import api from '@/helpers/api';

export default {
  fetchWebhookTypes({ commit, rootState }, merchantId) {
    commit('START_LOADING_WEBHOOK_TYPES');
    const endpoint = `/organisation/${rootState.organisation.currentOrganisation.id}/business/${merchantId}/webhook/types`;
    api('GET', endpoint, null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('SET_WEBHOOK_TYPES', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },

  fetchWebhookLogs({ commit, rootState }, payload) {
    commit('START_LOADING_WEBHOOK_LOGS');
    const endpoint = `/organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.merchant_id}/webhook/logs`;
    api('GET', endpoint, payload.data, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('SET_WEBHOOK_LOGS', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },

  fetchWebhooks({ commit, rootState }, payload) {
    commit('START_LOADING_WEBHOOKS');
    const endpoint = `/organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.businessId}/webhook/list`;
    api('GET', endpoint, payload.data, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('SET_WEBHOOKS', response.data.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  createWebhook({ commit, rootState }, payload) {
    commit('WEBHOOK_SAVED', false);
    const endpoint = `/organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.merchant_id}/webhook`;
    api('POST', endpoint, payload.data, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('WEBHOOK_SAVED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  updateWebhook({ commit, rootState }, payload) {
    commit('WEBHOOK_SAVED', false);
    const endpoint = `/organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.merchant_id}/webhook/${payload.webhook_id}`;
    api('PUT', endpoint, payload.data, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('WEBHOOK_SAVED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  deleteWebhook({ commit, rootState }, payload) {
    commit('WEBHOOK_DELETED', false);
    const endpoint = `/organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.merchant_id}/webhook/${payload.webhook_id}`;
    return api('DELETE', endpoint, null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('WEBHOOK_DELETED', payload.webhook_id);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  updateWebhookState({ commit, rootState }, payload) {
    commit('WEBHOOK_SAVED', false);
    const endpoint = `/organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.merchant_id}/webhook/${payload.webhook_id}/state`;
    return api('PUT', endpoint, payload.data, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('WEBHOOK_SAVED', payload.webhook_id);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
};
